import baseURL from '../modules/api/url'
import { strings } from '../context/LanguageContext/strings'
import { ManageImports } from '../constants/ManageImports'

export const ManageProductsImports = {
    getProductsImportsFilters: () => [
        {
            placed_at: 'tableToolBar',
            type: 'string',
            key: 'productIdOrName',
            display_name: strings.SECTION_MANAGE_PRODUCTS_IMPORTS_SEARCH_BY_PRODUCT_ID_OR_NAME,
            display_value: '',
            post_value: '',
            defaultDisplayValue: '',
            defaultPostValue: '',
        },
        {
            type: 'list',
            key: 'status',
            display_name: strings.STATUS,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const statuses = ManageImports.getStatuses()
                return list.map(item => statuses.find(s => s.value === item).display)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
        {
            type: 'list',
            key: 'action',
            display_name: strings.ACTION,
            display_value: [],
            post_value: [],
            displayPillUtil: list => {
                const actions = ManageImports.getActions()
                return list.map(item => actions.find(a => a.value === item).display)
            },
            defaultDisplayValue: [],
            defaultPostValue: [],
        },
    ],
    getProductsImportsTableHeaders: () => [
        {
            id: 'id',
            label: strings.SECTION_MANAGE_PRODUCTS_IMPORTS_TABLE_PRODUCT_ID,
            width: '20%',
            align: 'center',
        },
        {
            id: 'name',
            label: strings.SECTION_MANAGE_IMPORTS_TABLE_NAME,
            width: '20%',
        },
        {
            id: 'Image',
            label: strings.IMAGES,
            width: '20%',
        },
        {
            id: 'status',
            label: strings.STATUS,
            width: '25%',
        },
        {
            id: 'action',
            label: strings.ACTION,
            width: '20%',
        },
        {
            id: 'created_at',
            label: strings.SECTION_MANAGE_IMPORTS_TABLE_CREATE_AT,
            width: '20%',
        },
    ],
    productsImportsUrlPath: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalog/products/productImport`,

    productsImportsSyncUrlPath: `${baseURL.SEVEN_NOW_CORE_API_URL}/catalog/products/sync`,
}
